export default "__VITE_ASSET__DUTTCQjq__"